"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleFavorite = exports.Name = void 0;
const Name = exports.Name = 'open-back-in-stock-notification-dialog';
const ToggleFavorite = exports.ToggleFavorite = Name;
//# sourceMappingURL=index.js.map